import { Config } from './config.type'
const config: Config  = {
    "build": {
        "host": "https://graphql0.canvasflow.io",
        "subdirectory": "/",
        "website": "",
        "subscriptionUrl": "",
        "assetDirectory": "/",
        "title": "THE OG",
        "shortTitle": "THE OG",
        "appKey": "2fb4c243-922f-461d-b730-f2f23f34f14c",
        "language": "en",
        "languages": [
            "en"
        ],
        "about": "",
        "buildNumber": 442649,
        "buildDate": "2025-04-14T19:19:51.153Z",
        "version": "2.10.1"
    },
    "app": {
        "contentProtection": false,
        "admin": true,
        "favorite": false,
        "auth": {
            "enabled": true,
            "type": "cognito",
            "config": {
                "host": "https://auth.theog.digital",
                "clientId": "6n74ffm75i3fh60joreeauvbha",
                "customerPortalUrl": null
            }
        },
        "hideNavbarOnScroll": false,
        "installationOption": {
            "enabled": false
        },
        "password": {
            "enabled": false,
            "value": ""
        },
        "template": {
            "type": "basic",
            "config": {
                "sections": false
            }
        },
        "menu": {
            "links": []
        }
    },
    "issue": {
        "contentType": "responsive-replica",
        "lastLocation": {
            "enabled": false
        }
    },
    "analytics": {
        "tealium": {
            "ChannelID": "",
            "pageType": "",
            "pageDetail": "",
            "pageTemplate": "",
            "projectType": "",
            "url": ""
        },
        "google": {
            "trackerID": "",
            "sampleRate": 1
        },
        "ga4": {
            "trackerID": "",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": ""
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "onetrust": {
            "id": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": ""
        },
        "matomo": {
            "domain": ""
        }
    }
};
export default config;